import React, { useState, useEffect } from 'react';
import { useAuth } from "../../contexts/authContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useNavigate } from 'react-router-dom';
import AddTicket from './addticket';

export default function Tickets() {
  const [activeTab, setActiveTab] = useState('all');
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userDocId, currentUser, userData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userDocId) return;

    const fetchTickets = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "tickets"), where("userID", "==", userDocId));
        const docSnap = await getDocs(q);

        if (!docSnap.empty) {
          const ticketsData = docSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
          setTickets(ticketsData);
        } else {
          setTickets([]);
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
      setLoading(false);
    };

    fetchTickets();
  }, [userDocId]);

  if (!currentUser) return <div className="text-center text-gray-600 mt-10">Please log in to view your tickets.</div>;
  if (!userData) return <div className="text-center text-gray-600 mt-10">Loading profile...</div>;

  return (
    <div className="p-6 px-10 md:px-[15%] pt-20">
      <div className="flex justify-center space-x-4 mb-6">
        <button
          className={`px-6 py-2 rounded-lg font-medium transition-all duration-300 ${activeTab === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
          onClick={() => setActiveTab('all')}
        >
          All Tickets
        </button>
        <button
          className={`px-6 py-2 rounded-lg font-medium transition-all duration-300 ${activeTab === 'add' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
          onClick={() => setActiveTab('add')}
        >
          Add Ticket
        </button>
      </div>

      {activeTab === "add" ? (
        <AddTicket onBack={() => setActiveTab("all")} />
      ) : loading ? (
        <div className="text-center text-gray-600">Loading tickets...</div>
      ) : tickets.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg overflow-hidden border border-gray-300">
            <thead>
              <tr className="bg-blue-600 text-white">
                <th className="p-4 text-left">Ticket No.</th>
                <th className="p-4 text-left">Status</th>
                <th className="p-4 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map(ticket => (
                <tr key={ticket.id} className="border-b border-gray-300 hover:bg-gray-100 transition-all duration-200">
                  <td className="p-4 font-medium text-gray-700">{ticket.ticketNumber}</td>
                  <td className="p-4 text-gray-600">{ticket.status?.toUpperCase()}</td>
                  <td className="p-4">
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg transition-all duration-300 hover:bg-blue-700"
                      onClick={() => navigate(`/ticket/ticketdetails/${ticket.ticketNumber}`, { state: { ticket } })}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center text-gray-600">No tickets found.</div>
      )}
    </div>
  );
}
